module.exports = __webpack_public_path__ + "static/audiens-0c0c7e83ea1dbfbe3ab06216b43fc3c1.png";